module.exports = __webpack_public_path__ + "static/media/4-Hearts.afe0511c.svg";